import React, { useEffect } from 'react';

import {
  GridRowId,
  GridToolbar,
  GridToolbarProps,
  ToolbarPropsOverrides,
  gridPaginatedVisibleSortedGridRowIdsSelector,
  useGridApiContext,
  useGridSelector,
} from '@mui/x-data-grid';

declare module '@mui/x-data-grid' {
  interface ToolbarPropsOverrides {
    onVisibleRowIds?: (ids: Array<GridRowId>) => void;
  }
}

export default function AssignmentsToolbar({
  onVisibleRowIds,
  ...toolbarProps
}: GridToolbarProps & ToolbarPropsOverrides) {
  const apiRef = useGridApiContext();
  const visibleRowIds = useGridSelector(apiRef, gridPaginatedVisibleSortedGridRowIdsSelector);

  useEffect(() => {
    onVisibleRowIds?.(visibleRowIds);
  }, [onVisibleRowIds, visibleRowIds]);

  return <GridToolbar {...toolbarProps} />;
}
